import { authCall } from '.'
import { DashboardStatisticsResponse } from '../interfaces/dashboard'
import { estates } from './endpoints'

const DashboardService = {
  getEstateStat: (estateId: string) => {
    const url = `${estates}/${estateId}/dashboard`
    return authCall<DashboardStatisticsResponse>({
      url,
      method: 'get',
    })
  },
}

export default DashboardService
